/*
  Lightweight replacement for lazysizes (same markup + classes, much less main-thread work).
  Handles: .lazyload with data-src / data-srcset / data-sizes="auto" / data-bg, <picture> sources,
  and elements added later (quick view, AJAX). Class flow matches lazysizes:
  lazyload -> lazyloading -> lazyloaded (theme CSS fades .lazyload in on .lazyloaded).
  data-load-after: load once the page has finished loading (or as soon as it is actually on screen), for images
  just below the fold that would otherwise compete with the LCP image on slow phones (e.g. carousels).
*/
(function () {
  'use strict';
  function load(el) {
    if (!el.classList.contains('lazyload')) return;
    el.classList.remove('lazyload');
    el.classList.add('lazyloading');
    var done = function () { el.classList.remove('lazyloading'); el.classList.add('lazyloaded'); };
    if (el.dataset.bg) { el.style.backgroundImage = 'url("' + el.dataset.bg + '")'; done(); return; }
    var picture = el.parentNode && el.parentNode.tagName === 'PICTURE' ? el.parentNode : null;
    if (picture) picture.querySelectorAll('source[data-srcset]').forEach(function (s) { s.srcset = s.dataset.srcset; });
    if (el.dataset.sizes === 'auto') el.sizes = Math.max(el.offsetWidth, el.parentNode ? el.parentNode.offsetWidth : 0, 100) + 'px';
    else if (el.dataset.sizes) el.sizes = el.dataset.sizes;
    if (el.tagName === 'IMG' || el.tagName === 'IFRAME') {
      el.addEventListener('load', done, { once: true });
      el.addEventListener('error', done, { once: true });
    }
    if (el.dataset.srcset) el.srcset = el.dataset.srcset;
    if (el.dataset.src) el.src = el.dataset.src;
    if (el.tagName !== 'IMG' && el.tagName !== 'IFRAME') done();
    else if (el.complete && el.tagName === 'IMG' && (el.currentSrc || el.src)) done();
  }
  var io = 'IntersectionObserver' in window ? new IntersectionObserver(function (entries) {
    entries.forEach(function (e) { if (e.isIntersecting) { io.unobserve(e.target); load(e.target); } });
  }, { rootMargin: '400px 0px' }) : null;
  var pageLoaded = document.readyState === 'complete';
  var ioVisible = 'IntersectionObserver' in window ? new IntersectionObserver(function (entries) {
    entries.forEach(function (e) { if (e.isIntersecting) { ioVisible.unobserve(e.target); load(e.target); } });
  }) : null;
  function watch(el) {
    if (el.hasAttribute('data-load-after') && !pageLoaded) { ioVisible ? ioVisible.observe(el) : load(el); return; }
    io ? io.observe(el) : load(el);
  }
  function observe(root) {
    (root.querySelectorAll ? root.querySelectorAll('.lazyload') : []).forEach(watch);
    if (root.classList && root.classList.contains('lazyload')) watch(root);
  }
  function afterLoad() {
    pageLoaded = true;
    document.querySelectorAll('.lazyload[data-load-after]').forEach(function (el) { if (ioVisible) ioVisible.unobserve(el); load(el); });
  }
  if (!pageLoaded) window.addEventListener('load', function () { setTimeout(afterLoad, 0); });
  function init() {
    observe(document);
    new MutationObserver(function (muts) {
      muts.forEach(function (m) { m.addedNodes.forEach(function (n) { if (n.nodeType === 1) observe(n); }); });
    }).observe(document.documentElement, { childList: true, subtree: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  window.lazySizes = window.lazySizes || { loader: { unveil: load } };
})();
